import React, { Component, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";

const AudienceCounts = (props) => {
    const [haveAudienceData, setHaveAudienceData] = React.useState(false);
    const data = {
        labels: props?.data?.map(item => item.type) || ["Male", "Female", "Others"],
        datasets: [
            {
                data: props?.data?.map(item => item.totalCount) || [0, 0, 0],
                borderWidth: 3,
                borderColor: "rgba(255,255,255,1)",
                backgroundColor: [
                    "rgba(251, 62, 122, 1)",
                    "rgba(14, 138, 116, 1)",
                    "rgba(255, 123, 49, 1)"
                ],
                hoverBackgroundColor: [
                    "rgba(251, 62, 122, 0.5)",
                    "rgba(14, 138, 116, 0.5)",
                    "rgba(255, 123, 49, 0.5)"
                ]
            }
        ]
    };

    useEffect(() => {
        let tmpHaveAudienceData = false;

        if (props?.data?.length > 0) {
            for (let i = 0; i < props?.data?.length; i++) {
                if (props.data[i].totalCount > 0) {
                    tmpHaveAudienceData = true;
                    break;
                }
            }
        }
        setHaveAudienceData(tmpHaveAudienceData);
    }, [props.data]);

    const options = {
        weight: 1,
        cutout: "60%",
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
            tooltip: {
                enabled: true,
                callbacks: {
                    label: function (context) {
                        const label = context.label || "";
                        const value = context.raw;
                        return `${label}: ${value}`;
                    }
                }
            },
            legend: {
                display: true,
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    padding: 20,
                    font: {
                        size: 12,
                        family: "Poppins"
                    }
                }
            }
        }
    };


    return (
        <div className="card event-bx">
            <div className="card-header border-0 mb-0">
                <h4 className="card-title mb-1 font-w500">Audience</h4>
            </div>
            <div className="card-body dz-scroll">
                {haveAudienceData ? (
                    <Doughnut data={data} height={100} options={options} />
                ) : (
                    <div className="text-center h-100 d-flex justify-content-center align-items-center"><h4>No Audience Data Available</h4></div>
                )}
            </div>
        </div>
    );
}

export default AudienceCounts;